import {
  Briefcase,
  Car,
  CircleEllipsis,
  Fuel,
  Gamepad2,
  HeartPulse,
  House,
  PartyPopper,
  PawPrint,
  PiggyBank,
  Repeat,
  Tag,
  Utensils,
  type LucideIcon,
} from "lucide-react";
import type { Category } from "@/lib/types";

const ICONS: Record<string, LucideIcon> = {
  house: House,
  car: Car,
  "heart-pulse": HeartPulse,
  utensils: Utensils,
  "party-popper": PartyPopper,
  fuel: Fuel,
  "gamepad-2": Gamepad2,
  "paw-print": PawPrint,
  briefcase: Briefcase,
  repeat: Repeat,
  "piggy-bank": PiggyBank,
  "circle-ellipsis": CircleEllipsis,
};

export function CategoryIcon({
  category,
  parent,
  size = 36,
}: {
  category?: Category | null;
  parent?: Category | null;
  size?: number;
}) {
  const root = parent ?? category;
  const Icon = (root?.icon && ICONS[root.icon]) || Tag;
  const color = category?.color ?? root?.color ?? "var(--muted)";
  return (
    <span
      className="grid shrink-0 place-items-center rounded-[10px]"
      style={{
        width: size,
        height: size,
        background: `color-mix(in oklab, ${color} 16%, transparent)`,
        color,
      }}
      aria-hidden
    >
      <Icon style={{ width: size * 0.5, height: size * 0.5 }} strokeWidth={1.9} />
    </span>
  );
}
